export default {
    noResultsText: 'No results found',
    searching: 'Searching...',
    minDigits: 'Please enter at least 3 characters',
}
